import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import NodeList from '@/components/common/Sidebar/NodeList.vue'
import NodeItem from '@/components/common/Sidebar/NodeItem.vue'
import { mapGetters, mapActions } from 'vuex';
import * as mailTypes from '@mail/store/types';
import api from '@mail/api'
import { i18n } from '@appbase/util';

export interface MenuInfo {
    name: string
    id: string
    icon: string
    select: boolean
    expand: boolean
    child?: MenuInfo[]
    path: string,
    type: string,
    wellKnownFolderName?: string
}

export const getMailBoxIcon = function(wellknownFolderName: string): string  {
    var returnIcon;
    switch (wellknownFolderName) {
        case "inbox":
            returnIcon = "inbox";
            break;
        case "sentitems":
            returnIcon = "send";
            break;
        case "outbox":
            returnIcon = "send";
            break;
        case "drafts":
            returnIcon = "box";
            break;
        case "junkemail":
            returnIcon = "denied";
            break;
        case "deleteditems":
            returnIcon = "bin";
            break;
        default:
            returnIcon = "box";
            break;
    }
    return returnIcon;
}

export const getMailBoxName = function(wellknownFolderName: string): string  {
    var name;
    switch (wellknownFolderName) {
        case "inbox":
            name = i18n.t('W_Mail_FolderInbox').toString();
            break;
        case "sentitems":
            name = i18n.t('W_Mail_FolderSentbox').toString();
            break;
        case "drafts":
            name = i18n.t('W_Mail_FolderDrafts').toString();
            break;
        case "deleteditems":
            name = i18n.t('W_Mail_FolderDeletedItems').toString();
            break;
        default:
            name = wellknownFolderName;
            break;
    }
    return name;
}

@Component({
    components: { NodeList, NodeItem },
    computed: {
        ...mapGetters({
            folders: mailTypes.FOLDER_LIST,
        }),
    },

    methods: {
        ...mapActions({
            load: mailTypes.FOLDER_LOAD,
        }),
    },
})


export default class MailFolderList extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    folders!: mail.MailboxFolder[];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    load!: (parentId?: string) => Promise<void>;
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    menus: MenuInfo[] = [
        {
            name: this.$t('메일_홈').toString(),
            id: '',
            icon: 'home2',
            select: false,
            expand: false,
            path: 'mail-home',
            type: 'router-link'
        },
        {
            name: this.$t('W_Mail_Favorites').toString(),
            id: '',
            icon: 'star',
            select: false,
            expand: true,
            child: [],
            path: 'mail-home',
            type: ''
        }
    ]

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    createdMailMenu() {
        this.getMailFolder()
        this.getMailFavoriteFolder()
    }

    getMailFolder(parentId?: string) {
        api.folder.getFolderTree(parentId).then((res) => {
            res.items.forEach(folder => {
                var folderItem: MenuInfo = {
                    name: '',
                    id: '',
                    icon:'',
                    select: false,
                    expand: false,
                    path: 'mail-list',
                    type: 'router-link',
                    child: []
                }
                folderItem.name = getMailBoxName(folder.name)
                folderItem.id = folder.id
                folderItem.icon = getMailBoxIcon(folder.wellKnownFolderName ? folder.wellKnownFolderName : '')
                folderItem.wellKnownFolderName = folder.wellKnownFolderName
                folderItem.expand = folder.childFolderCount > 0 ? true : false
    
                this.menus.push(folderItem)

                if (folder.hasChildren) {
                    this.makeMenu(folder.children, folderItem)
                }
            })
        })
    }

    makeMenu(folders: mail.MailboxFolder[] | null, parentMenu: MenuInfo) {
        api.folder.getFolderTree(parentMenu.id).then((res) => {
            res.items.forEach(folder => {
                var folderItem: MenuInfo = {
                    name: '',
                    id: '',
                    icon:'',
                    select: false,
                    expand: false,
                    path: 'mail-list',
                    type: 'router-link',
                    child: []
                }
    
                folderItem.name = folder.name
                folderItem.id = folder.id
                folderItem.icon = getMailBoxIcon(folder.wellKnownFolderName ? folder.wellKnownFolderName : '')
                folderItem.wellKnownFolderName = folder.wellKnownFolderName
                folderItem.expand = folder.childFolderCount > 0 ? true : false
    
                parentMenu.child?.push(folderItem)
    
                if (folder.hasChildren) {
                    this.makeMenu(folder.children, folderItem)
                }
            })
        })
    }

    getMailFavoriteFolder() {
        var favorite = this.menus.find(x => x.name == this.$t('W_Mail_Favorites').toString())?.child
        api.favorite.getFavorites().then((res) => {
            res.map((folder: any) => {
                var folderItem: MenuInfo = {
                    name: '',
                    id: '',
                    icon:'',
                    select: false,
                    expand: false,
                    path: 'mail-list',
                    type: 'router-link'
                }
                folderItem.name = folder.name
                folderItem.id = folder.id
                folderItem.icon = getMailBoxIcon(folder.wellKnownFolderName)
        
                favorite?.push(folderItem)
            })
        })
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.createdMailMenu()
    }
}